import { CSSProperties, FC } from 'react';
import { IntlShape } from 'react-intl';

import styles from './id.module.scss';

interface Props {
    collectionStyling?: boolean;
    id: number | string;
    intl: IntlShape;
    styles?: CSSProperties;
}

const Id: FC<Props> = ({ id, styles: stylesCustom, intl, collectionStyling = false }) => {
    // const isCollectionStyling = ()
    if (id && intl) {
        return (
            <div className={collectionStyling ? styles.collectionIdWrapper : styles.idWrapper} style={stylesCustom}>
                {intl.formatMessage({ id: 'general.id', defaultMessage: 'ID: {id}' }, { id })}
            </div>
        );
    }

    return null;
};

export default Id;
